$(window).load(function() {
  var maxHeight = 0;
  $(".prod-wrap").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $(".prod-wrap").height(maxHeight);

  var maxHeight = 0;
  $(".prod-wrap .prod-img").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });    
  $(".prod-wrap .prod-img").height(maxHeight);

//   var maxHeight = 0;
//   $(".cate-wrap").each(function () {
//     if ($(this).height() > maxHeight) {
//       maxHeight = $(this).height();
//     }
//   });
//   $(".cate-wrap").height(maxHeight);

//   var maxHeight = 0;
//   $(".cate-wrap .img").each(function () {
//     if ($(this).height() > maxHeight) {
//       maxHeight = $(this).height();
//     }
//   });
//   $(".cate-wrap .img").height(maxHeight);
});